import React from 'react';
import {
  AppButton,
  Box,
  Inscription,
  RawButton,
} from '@common-fe/common-fe';

import { EmployerStatus } from '@/modules/employer/employer.constants';

interface Props {
  title: string;
  description?: string;
  onViewDetails?: () => void;
  employerStatus?: EmployerStatus;
  terminationDate?: string | null;
  onCancelTermination: () => void;
  onTerminateEmployer: () => void;
}

export const TerminationDangerZoneCard: React.FC<Props> = ({
  title,
  description,
  onViewDetails,
  employerStatus,
  terminationDate,
  onCancelTermination,
  onTerminateEmployer,
}) => {
  return (
    <Box
      data-testid="EmployerTermination_DangerZone_container"
      fill
      align="center"
      pad="spacing24"
      round="container1Round"
      direction="column"
      background="canvas"
      margin={{ right: 'spacing8' }}
      style={{ position: 'relative' }}
    >
      <Inscription size="2xl" color="textBody" weight={700}>
        {title}
      </Inscription>
      
      {description ? (
        <Box margin={{ top: 'spacing12' }} direction="row" align="center">
          <Inscription color="textBody">
            {description}
          </Inscription>

          {onViewDetails && (
            <RawButton
              onClick={onViewDetails}
              style={{ marginLeft: '8px', marginBottom: '2px' }}
            >
              <Inscription color="textAccent" alignSelf="center" weight="normal">
                View Details
              </Inscription>
            </RawButton>
          )}
        </Box>
      ) : null}

      <Box
        width="100%"
        margin={{ top: 'spacing24' }}
        direction="row"
        gap="spacing12"
      >
        {employerStatus === EmployerStatus.PendingTermination || terminationDate ? (
          <Box fill>
            <AppButton
              testId="cancel-termination"
              buttonType="secondary"
              size="L"
              onClick={onCancelTermination}
              width="100%"
            >
              Cancel Termination
            </AppButton>
          </Box>
        ) : null}
        
        <Box fill>
          <AppButton
            testId="start-termination"
            color={employerStatus === EmployerStatus.PendingTermination || terminationDate ? 'blue' : 'red'}
            size="L"
            onClick={onTerminateEmployer}
            width="100%"
          >
            {employerStatus === EmployerStatus.PendingTermination || terminationDate ? 'Edit' : 'Terminate'}
          </AppButton>
        </Box>
      </Box>
    </Box>
  );
};